<script setup lang="ts">
import { ThemeType } from "@/stores/theme";
import { Radio, RadioGroup } from "@soft-db/ui";

const theme = defineModel<ThemeType>("theme", { required: true });

const { t } = useI18n();

const availableThemes = computed(() => [
	{
		label: t("profile.themeUseSystemDefault"),
		value: ThemeType.SYSTEM_DEFAULT,
	},
	{
		label: t("profile.themeLight"),
		value: ThemeType.LIGHT,
	},
	{
		label: t("profile.themeDark"),
		value: ThemeType.DARK,
	},
]);
</script>

<template>
	<RadioGroup v-model="theme">
		<div
			v-for="availableTheme of availableThemes"
			:key="availableTheme.value"
			class="flex items-center gap-2"
		>
			<Radio :id="availableTheme.label" :value="availableTheme.value" />
			<label :for="availableTheme.label" class="cursor-pointer text-sm">
				{{ availableTheme.label }}
			</label>
		</div>
	</RadioGroup>
</template>
